import { api } from "@api/api";
import { Voucher } from "@modules/vouchers/types";
import { VoucherFormValues } from "@modules/vouchers/validations";

export async function createVoucherService(data: VoucherFormValues): Promise<Voucher> {
  const { data: voucher } = await api.post<Voucher>("v1/voucher_batch_admin/", data);

  return voucher;
}
